export const addClassNameIfTrue = (flag, className) => {
  return flag ? className : '';
}